import { PaymentConfirmation } from "./PaymentConfirmation";
import { RedirectionExperience } from "./RedirectionExperience";

export const PostPaymentTab = () => {
  return (
    <>
      <PaymentConfirmation />
      <RedirectionExperience />
    </>
  )
};